export default __webpack_public_path__ + "static/media/logo-peca-ai.0ab48423.svg";